import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { environment } from '../../environments/environment';
import { InviteShareComponent, InviteShareData } from './invite-share.component';

/**
 * Desktop width. The redesigned screen lays the card beside the picker and
 * buttons once it has the room (a container query in its stylesheet), so it
 * asks for a wide dialog; the legacy screen is a single narrow column.
 */
export const INVITE_SHARE_DESKTOP_WIDTH = environment.features.newInviteDesign ? '880px' : '440px';

/**
 * Opens the redesigned share screen as a dialog, framed exactly like
 * start.component's post-creation flow (start.component.ts's
 * showInviteThenEvent) — every call site that switches from
 * InviteDialogComponent to this component under environment.features.
 * newInviteDesign should look identical, so this is the one place that
 * decides sizing/position rather than five copies of the same options object.
 *
 * Unlike InviteDialogComponent, this works fine on mobile as a dialog (it
 * anchors to the bottom of the screen), so callers no longer need a separate
 * `/invite-guests` route for small screens — that route, and
 * InviteDialogComponent, stay in place only for when the flag is off.
 */
export function openInviteShareDialog(dialog: MatDialog, data: InviteShareData): MatDialogRef<InviteShareComponent> {
  const isMobile = window.innerWidth <= 768;
  return dialog.open(InviteShareComponent, {
    data,
    width: isMobile ? '100vw' : INVITE_SHARE_DESKTOP_WIDTH,
    maxWidth: isMobile ? '100vw' : '90vw',
    // Without this the dialog can grow taller than the viewport with no way
    // to reach what's below the fold — Material's own container scrolls once
    // it's actually capped.
    maxHeight: '90vh',
    position: isMobile ? { bottom: '0' } : undefined,
    panelClass: isMobile ? 'invite-share-panel-mobile' : 'invite-share-panel',
    hasBackdrop: true,
    backdropClass: 'invite-share-backdrop',
    autoFocus: false,
  });
}
